import { onBeforeUnmount, ref } from 'vue'

export const useReactiveCurrentDate = () => {
  const now = ref(new Date())

  // No ticking during SSR: onBeforeUnmount never fires there, so the
  // interval would leak in the node process on every server render.
  if (typeof window !== 'undefined') {
    const nowInterval = setInterval(() => {
      now.value = new Date()
    }, 1000)
    onBeforeUnmount(() => clearInterval(nowInterval))
  }

  return {
    now,
  }
}
